
export const pusherAppId = '9b83f71d2f2d0269ba9a';
export const serverApi = 'https://cfv-api.feral.lt/index.php';
// export const serverApi = 'http://localhost:8090/index.php';
